import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class PostalCode extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): PostalCode {
    const regex = new RegExp(this.validationRule.pattern.value);
    if (!regex.test(value)) {
      throw new Error(this.validationRule.pattern.message);
    }
    return new PostalCode(value);
  }

  /** ラベル */
  static get label(): string {
    return '郵便番号';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '012-1234';
  }

  /** タイプ */
  static get type() {
    return 'text';
  }

  /** キー */
  static get key() {
    return 'postalCode';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
      /** パターン */
      pattern: {
        /** 値 */
        value: /^[0-9]{3}-[0-9]{4}$/,
        /** メッセージ */
        message: '郵便番号の形式が不正です',
      },
    };
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
